module.exports = __webpack_public_path__ + "static/any-do-936988c3ffc90825357d991df28b05b0.png";